import { render } from "./Diet.vue?vue&type=template&id=f180ee1a"
import script from "./Diet.vue?vue&type=script&lang=js"
export * from "./Diet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/quiz/routes/Diet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f180ee1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f180ee1a', __exports__)) {
    api.reload('f180ee1a', __exports__)
  }
  
  module.hot.accept("./Diet.vue?vue&type=template&id=f180ee1a", () => {
    api.rerender('f180ee1a', render)
  })

}


export default __exports__